import ActionCable from 'actioncable';
import { getToken } from './jwt.service';

export default {
  subscribe(channel, id, callback) {
    const token = getToken();
    const cable = ActionCable.createConsumer(`${import.meta.env.VITE_APP_WEBSOCKET_URL}?token=${btoa(token)}`);
    return cable.subscriptions.create({ channel, id }, callback);
  },
  unsubscribe(channel) {
    if (channel) {
      channel.unsubscribe();
    }
  },
};
